export default __webpack_public_path__ + "static/media/cross-icon.1665e8f5.svg";